<template>
  <div class="nix-send-confirm" v-if="!stopSend">
    <Timer
      :title="'Enviando confirmação para ' + email + mobile + ' em'"
      :initialTimer="10"
      :endTime="sendConfirm"
    />
    <div class="nix-send-confirm__btn">
      <Button
        _key="cancel"
        type="danger"
        title="Cancelar"
        classIcon="fa-solid fa-ban"
        size="small"
        :clicked="cancel"
      />
    </div>
  </div>
</template>

<script>
import Button from '@/ui/forms/Button.vue'
import Timer from '@/ui/shared/Timer.vue'
import { authService } from '@/modules/auth/services/auth.service'
import { mapMutations } from 'vuex'

export default {
  name: 'SendConfirmMailMobile',
  components: { Button, Timer },
  props: {
    typeConfirm: String,
    email: {
      type: String,
      default: '',
    },
    mobile: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      stopSend: false,
    }
  },
  methods: {
    ...mapMutations('generic', ['addEvent', 'removeLoading']),
    async sendConfirm() {
      if (this.stopSend) return
      this.cancel()
      try {
        await authService.sendConfirmMailMobile({
          typeConfirm: this.typeConfirm,
          email: this.email,
          mobile: this.mobile,
        })
      } catch (e) {
        // erros já são exibidos pelo Messages
      }
    },
    cancel() {
      this.stopSend = true
      this.addEvent({ name: 'stopSendConfirmEmailMobile' })
      this.removeLoading(['cancel'])
    },
  },
}
</script>

<style scoped>
.nix-send-confirm {
  margin: 20px 0;
  text-align: center;
}

.nix-send-confirm__btn {
  margin-top: 10px;
}
</style>
